import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Form from '@panneau/form';
import Dialog from '@panneau/modal-dialog';

var _excluded = ["id", "title", "name", "fields", "action", "type", "item", "onComplete", "onClose", "submitButtonLabel", "className", "children"];
var propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.node,
  name: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  action: PropTypes.string,
  type: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string
  }),
  onComplete: PropTypes.func,
  onClose: PropTypes.func,
  submitButtonLabel: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node
};
var defaultProps = {
  title: null,
  name: null,
  fields: null,
  action: null,
  type: 'normal',
  item: null,
  onComplete: null,
  onClose: null,
  submitButtonLabel: null,
  className: null,
  children: null
};
function ModalForm(_ref) {
  var id = _ref.id,
    title = _ref.title,
    name = _ref.name,
    fields = _ref.fields,
    action = _ref.action,
    type = _ref.type,
    item = _ref.item,
    onComplete = _ref.onComplete,
    onClose = _ref.onClose,
    submitButtonLabel = _ref.submitButtonLabel,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    title: title || (name !== null ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "smqUAV",
      defaultMessage: [{
        "type": 0,
        "value": "Edit "
      }, {
        "type": 1,
        "value": "name"
      }],
      values: {
        name: name
      }
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "T/NPHK",
      defaultMessage: [{
        "type": 0,
        "value": "Edit"
      }]
    })),
    size: "lg",
    onClose: onClose,
    className: className
  }, children, /*#__PURE__*/React.createElement(Form, Object.assign({}, props, {
    fields: fields,
    action: action,
    type: type,
    item: item,
    buttonSize: "md",
    onComplete: onComplete,
    onCancel: onClose,
    submitButtonLabel: submitButtonLabel
  })));
}
ModalForm.propTypes = propTypes;
ModalForm.defaultProps = defaultProps;

export { ModalForm as default };
